import { styles as stylesSyncHistory } from "../../admin/VehicleSingleRegistrySyncHistoryPage/VehicleSingleRegistrySyncHistoryPage.styles";
export const styles = {
  ...stylesSyncHistory,
  page: {
    display: "flex",
    flexDirection: "column",
  },
  pageContent: {
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    ...stylesSyncHistory.cardHeader,
    flex: "1",
  },
  subtitleText: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#1E293B",
  },
  filtersArea: {
    ...stylesSyncHistory.filtersArea,
    padding: "20px 0",
  },
  backContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: "40px",
    padding: "30px 0 15px",
  },
  divider: {
    border: "none",
    height: "1px",
    backgroundColor: "#CBD5E1",
  },
  backLink: {
    display: "flex",
  },
};
